import script from "./AncestryLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./AncestryLanding.vue?vue&type=script&setup=true&lang=js"

import "./AncestryLanding.vue?vue&type=style&index=0&id=1fd87710&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd87710"]])

export default __exports__